export default {
  appCenter: {
    channel: "经营渠道",
    riderApp: "骑手app",
    miniProgram: "微信小程序",
    academy: "骑士学院",
    trainPlace: "培训地点",
    ranking: "排行榜",
    bond: "保证金",
    idCard: "身份证识别",
    sms: "短信设置",
    remoteAttach: "远程附件",
    mustSee: "必看",
  },
  train: {
    title: "培训列表",
    filterTitle: "培训地点筛选",
    place: "培训点",
    placePh: "请输入培训点",
    type: "培训类型",
    addPlace: "新增培训地点",
    name: "培训名称",
    address: "培训地点",
    contact: "负责人联系方式",
    trainDate: "培训日期",
    trainTime: "培训时间",
    enrollLimit: "报名上限/已报名",
    displayStatus: "显示状态",
    typeAll: "全部",
    typeEntry: "入职培训",
    typeFull: "专职培训",
    typeOther: "其他培训",
  },
  learnings: {
    title: "骑士学院",
    participants: "参与人数(人)",
    typeAll: "全部",
    typeEntry: "入职考试",
    typeSpecial: "专项考试",
    addBank: "新增题库",
    bankTitle: "题库标题",
    topicCount: "题目数量",
    viewBank: "查看题库",
    addSubject: "新建题目",
    answerOptions: "答案选项",
    score: "分数",
  },
  ranking: {
    title: "骑手单量排行榜",
  },
  bond: {
    title: "保证金管理",
    list: "保证金列表",
    settingsTab: "保证金设置",
    amount: "保证金金额",
    paid: "已缴纳",
    refundApplying: "骑手申请退还保证金",
    refunded: "已退还保证金",
    refundRejected: "拒绝退还保证金",
    payTime: "缴纳时间",
    applyRefund: "申请退",
    refundedShort: "已退",
    rejectRefund: "拒绝退",
    settings: {
      customName: "名称自定义",
      customNamePh: "请输入保证金名称",
      amount: "保证金金额",
      amountPh: "请输入保证金金额",
      refund: "保证金退还",
      refundDays: "退还保证金天数",
      refundDaysPh: "请输入退还保证金天数",
      dayUnit: "天",
      agreement: "保证金协议",
      agreementPh: "请输入保证金协议",
      explain: "保证金说明",
      explainPh: "请输入保证金说明",
    },
  },
  appSet: {
    title: "骑手App绑定流程",
    subtitle: "骑手app下载以及接单流程",
    viewTutorial: "查看教程",
    step1Title: "第一步：先用手机浏览器扫描或下载骑手端app",
    step1Desc1: "骑手需要先下载配送端app，下载链接：",
    step1Desc2: "，或扫描右侧二维码下载",
    step2Title: "第二步：打开骑手app并绑定当前域名和平台ID",
    step2Desc1: "骑手在注册或登录前需要先绑定平台域名",
    step2Desc2: "，以及平台ID：",
    step2Desc3: "来识别身份。",
    step3Title: "第三步：骑手注册并认证身份后，即可抢单配送了",
    step3Desc: "平台必须先配置短息设置以及百度身份证号识别功能，否则骑手无法正常注册。",
    downloadNow: "立即下载",
    preview: "操作预览",
    configureNow: "立即配置",
  },
  miniappSet: {
    tabBasic: "基础设置",
    tabUserList: "用户列表",
    tabDownload: "小程序下载",
    miniName: "小程序名称",
    miniNamePh: "请输入小程序名称",
    miniAppId: "AppID(小程序ID)",
    miniAppIdPh: "请输入小程序AppID",
    miniSecret: "AppSecret(小程序密钥)",
    miniSecretPh: "请输入小程序AppSecret",
    appIdHint: "获取方式：微信公众平台-开发-开发设置-开发者ID-小程序AppID",
    appSecretHint: "获取方式：微信公众平台-开发-开发设置-开发者ID-小程序AppSecret",
    userInfo: "用户信息",
    linkedRider: "关联骑手",
    regTime: "注册时间：",
    step1Title: "下载并安装微信小程序开发者工具，如果已经安装可跳过这一步。",
    downloadDevTool: "下载微信开发者工具",
    step2Title: "下载小程序代码包，并解压。",
    downloadCodePack: "下载小程序代码包",
    step3Title: "运行微信小程序开发者工具，选择打开项目，打开解压出来的小程序代码包，点击上传。",
    validateMiniName: "请输入小程序名称",
    validateAppId: "请输入AppId",
    validateSecret: "请输入appSecret",
  },
  applicationList: {
    tools: "配套工具",
    sms: "短信设置",
    smsDesc: "阿里云短信设置",
    remoteAttach: "远程附件",
    remoteAttachDesc: "图片云存储设置",
    mustConfig: "必配",
  },
  activity: {
    title: "活动中心",
    name: "活动名称",
    namePh: "请输入活动名称",
    add: "新增活动",
    enrollTime: "报名时间",
    type: "活动类型",
    firstOrderReward: "首单奖",
    rushReward: "冲单奖",
    completeOrders: "完成单量(单)",
    completeReward: "完成奖励",
    joinComplete: "报名人数/达成人数",
    status: "活动状态",
    notStarted: "未开始",
    inProgress: "进行中",
    ended: "已结束",
  },
  activityForm: {
    sort: "排序",
    sortPh: "数值从小到大排序，数值越小越靠前",
    namePh: "请输入名称",
    enrollTime: "报名时间",
    activityType: "活动类型",
    completeOrders: "完成单量",
    completeOrdersPh: "请输入完成多少单达成任务",
    completeReward: "完成奖励",
    completeRewardPh: "请输入完成奖励",
    activityDate: "活动日期",
    activityTime: "活动时间",
    startTimePh: "起始时间",
    endTimePh: "结束时间",
    addTimeSlot: "添加时间段",
    activityDesc: "活动说明",
    sortRequired: "请输入排序号",
    sortNumber: "排序必须为数字值",
    nameRequired: "请输入活动名称",
    enrollTimeRequired: "请选择报名时间段",
    typeRequired: "请选择活动类型",
    conditionRequired: "请输入完成单量",
    conditionNumber: "单量必须为数字值",
    rewardRequired: "请输入奖励金额",
    rewardNumber: "奖励金额必须为数字值",
    activityTimeRequired: "请选择活动时间段",
    timeSlotIncomplete: "请填写完整起止时间段！",
  },
  appointment: {
    title: "预约列表",
    batchArrive: "批量到达",
    batchNotArrive: "批量未到达",
    enrollTime: "报名时间",
    arriveTime: "到达时间",
    trainStatus: "培训状态",
    pendingConfirm: "待确认",
    arrived: "已到达",
    notArrived: "未到达",
    markArrived: "已到达",
    markNotArrived: "未到达",
  },
  classify: {
    title: "分类列表",
    add: "添加分类",
    edit: "编辑",
    name: "标题",
    namePh: "请输入标题",
    manage: "分类管理",
  },
  activityParticipants: {
    title: "活动参与人数列表",
    realName: "真实姓名",
    accountName: "账户名称",
    enrollTime: "报名时间",
    completedOrders: "已完成单数",
    completeStatus: "完成状态",
    completed: "已完成",
    notCompleted: "未完成",
    rewardIssue: "奖励发放",
  },
  examPass: {
    title: "考试通过人数列表",
    realName: "真实姓名",
    accountName: "账户名称",
    enrollTime: "报名时间",
    status: "状态",
    passed: "已通过",
    notPassed: "未通过",
    contact: "联系方式",
  },
};
